import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { PHONE_FORMAT } from '../../../../constants';
import { useStore } from '../../../../store/rootStore';
import { getDirection } from '../../../../helpers';
import s from './PhoneFormatSelect.module.scss';
const { Option } = Select;
const PhoneFormatSelect = () => {
    const { phoneFormat, setPhoneFormat } = useStore();
    const { t } = useTranslation();
    const handleChange = (value) => {
        setPhoneFormat(value);
    };
    return (React.createElement(Select, { className: s.select, onChange: handleChange, value: phoneFormat, direction: getDirection() === 'rtl' ? 'rtl' : 'ltr', popupClassName: s.dropdown, size: "small" }, Object.values(PHONE_FORMAT).map((format) => {
        return (React.createElement(Option, { key: format, value: format }, t(format)));
    })));
};
export default observer(PhoneFormatSelect);
